import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  meetings: [],
  wmeetings: [],
  meeting: {}
}

const mutations = {
  SET_MEETING (state, payload) {
    state.meeting = payload
  },
  SET_MEETINGS (state, payload) {
    state.meetings = payload
  },
  SET_WMEETINGS (state, payload) {
    state.wmeetings = payload
  },
  ADD_MEETINGS (state, payload) {
    state.meetings.push(payload)
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  },
  DELETE_MEETING (state, payload) {
    state.meetings = state.meetings.filter(element => {
      return element._id.toString() != payload.toString()
    })
  }
}

const actions = {
  meetingList: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting`)    
      .then((response) => {        
        context.commit('SET_MEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMeetingsByWeek: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting/by-week`)    
      .then((response) => {
        context.commit('SET_WMEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createMeeting: (context, data) => {
    return Vue.http.post(`${env.API}/api/meeting`, data)    
      .then((response) => {        
        context.commit('ADD_MEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMeetingsByPlan: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting/by-plan/${id}`)
      .then((response) => {        
        context.commit('SET_MEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getClosedMeetingsByUser: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    return Vue.http.get(`${env.API}/api/meeting/get-closed-meetings-by-user/${data.id}${query}`)
      .then((response) => {
        context.commit('SET_MEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMeetingDetailByMeetingAndUserId: (context, data) => {
    const {meetingId, userId} = data
    return Vue.http.get(`${env.API}/api/meeting/get-meeting-detail/${meetingId}/${userId}`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMeetingsByPlanOpen: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting/by-plan-open/${id}`)
      .then((response) => {        
        context.commit('SET_MEETINGS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMeetingById: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting/${id}`)    
      .then((response) => {
        context.commit('SET_MEETING', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  deleteMeeting: (context, id) => {
    return Vue.http.delete(`${env.API}/api/meeting/${id}`)    
      .then((response) => {  
        context.commit('DELETE_MEETING', id)              
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  newTheme: (context, data) => {
    return Vue.http.post(`${env.API}/api/meeting/new-theme`, data)    
      .then((response) => {                
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
    })
  },
  deleteTheme: (context, id) => {
    return Vue.http.delete(`${env.API}/api/meeting/remove-theme/${id}`)
    .then((response) => {
      return response.body.success
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })  
  },
  listCommitments: (context, userLeader) => {
    return Vue.http.get(`${env.API}/api/meeting/commitments/${userLeader}`)    
      .then((response) => {         
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  listProblems: (context, userLeader) => {
    return Vue.http.get(`${env.API}/api/meeting/problems/${userLeader}`)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  listThemes: (context, id) => {
    return Vue.http.get(`${env.API}/api/meeting/themes/${id}`)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  finishMeeting: (context, data) => {
    const { id, assistants, userLeader } = data
    return Vue.http.put(`${env.API}/api/meeting/close/${id}`, { assistants, userLeader })    
      .then((response) => {       
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateMeeting: (context, data) => {
    return Vue.http.put(`${env.API}/api/meeting/${data._id}`, data)    
    .then((response) => {       
      return response.success
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  }
}

const getters = {
  getMeetings: (state) => state.meetings,
  getWMeetings: (state) => state.wmeetings,
  getMeeting: (state) => (id) => state.meeting
}

export const meeting = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/meeting.js